import { TranslateService } from '@ngx-translate/core';
import { TrendingItem } from '@store';
import { uniqBy } from 'lodash';
import { Unit } from 'src/app/shared/common/units';

export class TrendChartsLabels {
  readonly primaryTrends: TrendingItem[] = [
    {
      feature: 'heating.heat.production.current/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.HEAT_PRODUCTION_CURRENT'
      ),
      unit: 'kW',
      visible: true,
    },
    {
      feature: 'heating.boiler.sensors.temperature.commonSupply/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_TEMPERATURE_COMMON_SUPPLY_VALUE'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.sensors.temperature.systemReturn/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_TEMPERATURE_SYSTEM_RETURN'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'fuelCell.electricalEnergyConsumption.value/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FUEL_CELL_FEATURE.ELECTRICAL_ENERGY_CONSUMPTION'
      ),
      unit: 'Wh',
      visible: true,
    },
    {
      feature: 'fuelCell.managers.energy.prediction.power.consumption/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FUEL_CELL_ENERGY_PREDICTION_POWER_CONSUMPTION'
      ),
      unit: 'Wh',
      visible: true,
    },
    {
      feature: 'fuelCell.managers.energy.prediction.runtime/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FUEL_CELL_ENERGY_PREDICTION_RUNTIME'
      ),
      unit: 'h',
      visible: true,
    },
    {
      feature: 'fuelCell.managers.energy.timeTillNextStart/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FUEL_CELL_TIME_TILL_NEXT_START'
      ),
      unit: 'h',
      visible: true,
    },
    {
      feature: 'fuelCell.prediction.heating.deficit/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FUEL_CELL_PREDICTION_HEATING_DEFICIT'
      ),
      unit: 'kJ',
      visible: true,
    },
    {
      feature: 'fuelCell.statistics/productionHoursPerDay',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.PRODUCTION_HOURS_FUEL_CELL_PER_DAY'
      ),
      unit: 'h',
      visible: true,
    },
    {
      feature: 'heating.compressors.0.power/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.NOMINAL_POWER_COMPRESSOR'
      ),
      unit: 'kW',
      visible: true,
    },
    {
      feature: 'heating.compressors.1.power/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.NOMINAL_POWER_COMPRESSOR'
      ),
      unit: 'kW',
      visible: true,
    },
    {
      feature: 'heating.compressors.2.power/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.NOMINAL_POWER_COMPRESSOR'
      ),
      unit: 'kW',
      visible: true,
    },
    {
      feature: 'heating.compressors.3.power/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.NOMINAL_POWER_COMPRESSOR'
      ),
      unit: 'kW',
      visible: true,
    },
    {
      feature: 'heating.compressors.0.sensors.power/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.CURRENT_POWER_COMPRESSOR'
      ),
      unit: '%',
      visible: true,
    },
    {
      feature: 'heating.compressors.1.sensors.power/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.CURRENT_POWER_COMPRESSOR'
      ),
      unit: '%',
      visible: true,
    },
    {
      feature: 'heating.compressors.2.sensors.power/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.CURRENT_POWER_COMPRESSOR'
      ),
      unit: '%',
      visible: true,
    },
    {
      feature: 'heating.compressors.3.sensors.power/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.CURRENT_POWER_COMPRESSOR'
      ),
      unit: '%',
      visible: true,
    },
    {
      feature: 'heating.primaryCircuit.sensors.rotation/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.POWER_FAN'
      ),
      unit: '%',
      visible: true,
    },
    {
      feature: 'heating.primaryCircuit.sensors.temperature.supply/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FLOW_TEMP_PRIMARY_CIRCUIT'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.primaryCircuit.sensors.temperature.return/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.RETURN_TEMP_PRIMARY_CIRCUIT'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.burners.0.modulation/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.BURNER_MODULATION'
      ),
      unit: '%',
      visible: true,
    },
    {
      feature: 'fuelCell.statistics/productionHours',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.PRODUCTION_HOURS_FUEL_CELL'
      ),
      visible: true,
      unit: 'h',
      step: true,
    },
    {
      feature: 'heating.power.production.current/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.POWER_OUTPUT'
      ),
      unit: 'W',
      visible: true,
    },
  ];

  readonly secondaryTrends: TrendingItem[] = [
    {
      feature: 'heating.dhw.sensors.temperature.hotWaterStorage/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_TEMPERATURE_HOT_WATER_STORAGE'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.circuits.0.sensors.temperature.supply',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_TEMPERATURE_SUPPLY_0'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.circuits.1.sensors.temperature.supply',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_TEMPERATURE_SUPPLY_1'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.circuits.2.sensors.temperature.supply',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_TEMPERATURE_SUPPLY_2'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.circuits.3.sensors.temperature.supply',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_TEMPERATURE_SUPPLY_3'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.dhw.sensors.temperature.hotWaterStorage.midBottom/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.DHW_HOT_WATER_STORAGE_MID_BOTTOM'
      ),
      unit: '°C',
      visible: true,
    },

    {
      feature: 'heating.dhw.sensors.temperature.hotWaterStorage.middle/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.DHW_HOT_WATER_STORAGE_MIDDLE'
      ),
      unit: '°C',
      visible: true,
    },

    {
      feature: 'heating.boiler.sensors.temperature.commonReturn/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.BOILER_SENSORS_TEMPERATURE_COMMON_RETURN'
      ),
      unit: '°C',
      visible: true,
    },

    {
      feature: 'heating.sensors.valve.bufferDischargeThreeWayValve/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_VALVE_BUFFER_DISCHARGE_THREE_WAY_VALVE'
      ),
      unit: '%',
      visible: true,
    },
    {
      feature: 'heating.dhw.sensors.temperature.hotWaterStorage.bottom/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.HOT_WATER_STORAGE_TEMP.BOTTOM'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.dhw.sensors.temperature.hotWaterStorage.top/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.HOT_WATER_STORAGE_TEMP.TOP'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.circuits.0.sensors.temperature.supply/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_TEMPERATURE_SUPPLY_0'
      ),
      visible: true,
      unit: '°C',
    },
    {
      feature: 'heating.circuits.1.sensors.temperature.supply/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_TEMPERATURE_SUPPLY_1'
      ),
      visible: true,
      unit: '°C',
    },
    {
      feature: 'heating.circuits.2.sensors.temperature.supply/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_TEMPERATURE_SUPPLY_2'
      ),
      visible: true,
      unit: '°C',
    },
    {
      feature: 'heating.circuits.3.sensors.temperature.supply/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_TEMPERATURE_SUPPLY_3'
      ),
      visible: true,
      unit: '°C',
    },
    {
      feature: 'heating.buffer.sensors.temperature.main/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.BUFFER_TEMPERATURE_MAIN'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.circuits.0.temperature/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FLOW_TEMP_HEATING_CIRCUIT',
        { circuitId: 1 }
      ),
      visible: true,
      unit: '°C',
    },
    {
      feature: 'heating.circuits.1.temperature/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FLOW_TEMP_HEATING_CIRCUIT',
        { circuitId: 2 }
      ),
      visible: true,
      unit: '°C',
    },
    {
      feature: 'heating.circuits.2.temperature/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FLOW_TEMP_HEATING_CIRCUIT',
        { circuitId: 3 }
      ),
      visible: true,
      unit: '°C',
    },
    {
      feature: 'heating.circuits.3.temperature/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FLOW_TEMP_HEATING_CIRCUIT',
        { circuitId: 4 }
      ),
      visible: true,
      unit: '°C',
    },
    {
      feature: 'heating.solar.sensors.temperature.dhw/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SOLAR_DHW'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.solar.sensors.temperature.collector/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SOLAR_COLLECTOR_SENSOR'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.secondaryCircuit.sensors.temperature.supply/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.BOILER.SECONDARY_CIRCUIT_SUPPLY_TEMPERATURE'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.dhw.temperature.main/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.MAIN_TEMP_DHW'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.sensors.temperature.allengra/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.TEMP_ALLENGRA'
      ),
      unit: '°C',
      visible: true,
    },

    {
      feature: 'heating.secondaryCircuit.valves.fourThreeWay/current',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SEC_VALVES_FOURTHREE_WAY'
      ),
      unit: '%',
      visible: true,
    },
    {
      feature: 'heating.sensors.pressure.supply/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.HEATING_PRESSURE'
      ),
      unit: 'bar',
      visible: true,
    },
    {
      feature: 'heating.sensors.volumetricFlow.allengra/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.VOLUME_ALLENGRA'
      ),
      unit: 'l/h',
      visible: true,
    },
  ];

  readonly primarySecondaryTrends: TrendingItem[] = [
    {
      feature: 'heating.boiler.sensors.temperature.commonSupply/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_TEMPERATURE_COMMON_SUPPLY_VALUE'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.sensors.temperature.systemReturn/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_TEMPERATURE_SYSTEM_RETURN'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.sensors.temperature.hydraulicSeparator/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_HYDRAULIC_SEPARATOR'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.sensors.temperature.outside/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.SENSORS_TEMPERATURE_OUTSIDE_VALUE'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.sensors.temperature.return/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.RETURN_FLOW_TEMP'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.sensors.volumetricFlow.return/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.VOLUMETRIC_FLOW_ON_RETURN'
      ),
      unit: 'l',
      visible: true,
    },
    {
      feature: 'fuelCell.sensors.temperature.supply/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FUEL_CELL_FLOW_TEMP'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'fuelCell.sensors.temperature.return/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FUEL_CELL_RETURN_TEMP'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.fuelCell.sensors.temperature.return/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FUEL_CELL_RETURN_TEMP'
      ),
      unit: '°C',
      visible: true,
    },
  ];

  readonly coolingCircuitsPrimaryTrends: TrendingItem[] = [
    {
      feature: 'heating.sensors.valve.0.expansion/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.EXPANSION_VALVE'
      ),
      unit: '%',
      visible: true,
    },
    {
      feature: 'heating.compressors.0.sensors.temperature.outlet/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.TEMP_OUTLET'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.evaporators.0.sensors.temperature.liquid/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.EVAPORATORS_TEMP_LIQUID'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.compressors.0.sensors.temperature.inlet/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.TEMP_INLET'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.economizers.0.sensors.temperature.liquid/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.ECONOMIZERS_TEMP_LIQUID'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.compressors.0.sensors.temperature.motorChamber/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.MOTOR_CHAMBER'
      ),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.compressors.0.sensors.temperature.oil/value',
      label: this.translateService.instant('+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.TEMP_OIL'),
      unit: '°C',
      visible: true,
    },
    {
      feature: 'heating.compressors.0.speed.current/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.CURRENT_SPEED'
      ),
      unit: Unit.Rps,
      visible: true,
    },
    {
      feature: 'heating.sensors.valve.1.expansion/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.EXPANSION_VALVE_SEC'
      ),
      unit: '%',
      visible: true,
    },
    {
      feature: 'heating.primaryCircuit.fans.0.current/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FANS_PRIMARY'
      ),
      unit: '%',
      visible: true,
    },
    {
      feature: 'heating.primaryCircuit.fans.1.current/value',
      label: this.translateService.instant('+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FANS_SEC'),
      unit: '%',
      visible: true,
    },
    {
      feature: 'heating.compressors.0.sensors.pressure.inlet/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.PRESSURE_INLET'
      ),
      unit: 'bar',
      visible: true,
    },
    {
      feature: 'heating.compressors.0.sensors.pressure.outlet/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.PRESSURE_OUTLET'
      ),
      unit: 'bar',
      visible: true,
    },
  ];

  readonly allTrendsCombined: TrendingItem[] = uniqBy(
    [
      ...this.primaryTrends,
      ...this.secondaryTrends,
      ...this.primarySecondaryTrends,
      ...this.coolingCircuitsPrimaryTrends,
    ],
    'feature'
  );

  readonly booleanTrends: TrendingItem[] = [
    {
      feature: 'heating.heatingRod.status/level1',
      label:
        this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.HEATING_ROD_LVL'
        ) + ' 1',
      unit: ' on/off',
      visible: true,
    },
    {
      feature: 'heating.heatingRod.status/level2',
      label:
        this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.HEATING_ROD_LVL'
        ) + ' 2',
      unit: ' on/off',
      visible: true,
    },
    {
      feature: 'heating.heatingRod.status/level3',
      label:
        this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.HEATING_ROD_LVL'
        ) + ' 3',
      unit: ' on/off',
      visible: true,
    },
    {
      feature: 'heating.primaryCircuit.valves.fourWay/state',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FOUR_THREE_VALVE'
      ),
      unit: ' on/off',
      visible: true,
    },
  ];

  readonly enumMappedTrends: TrendingItem[] = [
    {
      feature: 'heating.dhw.pumps.primary/status',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.DHW_PUMPS_PRIMARY'
      ),
      visible: true,
    },
    {
      feature: 'heating.dhw.pumps.circulation/status',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.DHW_PUMPS_CIRCULATION'
      ),
      visible: true,
    },
    {
      feature: 'heating.boiler.pumps.internal/status',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.DHW_PUMPS_INTERNAL'
      ),
      visible: true,
    },
    {
      feature: 'heating.circuits.0.circulation.pump/status',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.CIRCUITS_0_CIRCULATION_PUMP'
      ),
      visible: true,
    },
    {
      feature: 'heating.circuits.1.circulation.pump/status',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.CIRCUITS_1_CIRCULATION_PUMP'
      ),
      visible: true,
    },
    {
      feature: 'heating.circuits.2.circulation.pump/status',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.CIRCUITS_2_CIRCULATION_PUMP'
      ),
      visible: true,
    },
    {
      feature: 'heating.circuits.3.circulation.pump/status',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.CIRCUITS_3_CIRCULATION_PUMP'
      ),
      visible: true,
    },
    {
      feature: 'fuelCell.managers.energy/historyReset',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FUEL_CELL_MANAGERS_ENERGY_HISTORY_RESET'
      ),
      visible: true,
    },
    {
      feature: 'heating.burner.preConditions/status',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.HEATING_BURNER_STATUS'
      ),
      visible: true,
    },
    {
      feature: 'fuelCell.operating.modes.active/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FUEL_CELL_OPERATING_MODE_STATUS'
      ),
      visible: true,
    },
    {
      feature: 'fuelCell.operating.phase/value',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FUEL_CELL_OPERATING_PHASE_STATUS'
      ),
      visible: true,
    },
    {
      feature: 'heating.heatingRod.status/level1',
      label:
        this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.HEATING_ROD_LVL'
        ) + '1',
      visible: true,
    },
    {
      feature: 'heating.heatingRod.status/level2',
      label:
        this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.HEATING_ROD_LVL'
        ) + '2',
      visible: true,
    },
    {
      feature: 'heating.heatingRod.status/level3',
      label:
        this.translateService.instant(
          '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.HEATING_ROD_LVL'
        ) + '3',
      visible: true,
    },
    {
      feature: 'heating.primaryCircuit.valves.fourWay/state',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.FOUR_THREE_VALVE'
      ),
      visible: true,
    },
  ];

  readonly pvVoltageTrends: TrendingItem[] = [
    {
      feature: 'dl.photovoltaic.string.voltage/stringOne',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.ENERGY_STORAGE.PV_STRING_ONE'
      ),
      unit: Unit.Voltage,
      visible: true,
    },
    {
      feature: 'dl.photovoltaic.string.voltage/stringTwo',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.ENERGY_STORAGE.PV_STRING_TWO'
      ),
      unit: Unit.Voltage,
      visible: true,
    },
    {
      feature: 'dl.photovoltaic.string.voltage/stringThree',
      label: this.translateService.instant(
        '+INSTALLATIONS.INSTALLATION.TRENDING.FEATURE.ENERGY_STORAGE.PV_STRING_THREE'
      ),
      unit: Unit.Voltage,
      visible: true,
    },
  ];

  constructor(private translateService: TranslateService) {}
}
